import { connect } from 'react-redux';
import { shouldShowVideoPanel, getVideo } from '../../selectors/conversation';
import {
    startVideo,
    closeVideoPanel,
    endVideo,
    toggleAudioStream,
    toggleVideoStream,
} from '../../actions';
import { RootState, VideoState } from '../../typedefs/store';
import Video from './Video';

const mapStateToProps = (state: RootState, ownProps: any) => {
    const video: VideoState = getVideo(state);
    return {
        shouldShow: shouldShowVideoPanel(state),
        remoteActive: video.remoteActive,
        remoteStreaming: video.remoteStreaming,
        remoteClosed: video.remoteClosed,
        localActive: video.localActive,
        connectionError: video.connectionError,
        audioMuted: video.audioMuted,
        videoMuted: video.videoMuted,
    };
};

const mapDispatchToProps = {
    startVideo,
    closeVideoPanel,
    endVideo,
    toggleAudioStream,
    toggleVideoStream,
};

export default connect(mapStateToProps, mapDispatchToProps)(Video);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/VideoContainer.tsx